import {IMatomoConfig} from '../../models/matomo.model';

/**
 * Method: Check the environment names a Matomo tracker and site, the one rule for loading and tracking
 * @param config - Matomo block of the environment
 */
export function isMatomoConfigured(config: IMatomoConfig): boolean {
  return !!config.trackerUrl && !!config.siteId;
}
